// Lib
import { createAction } from 'redux-actions';

export const UpdateAccount = createAction('UPDATE_ACCOUNT');
export const AccountLogout = createAction('ACCOUNT_LOGOUT');
export const AccountDataLoad = createAction('ACCOUNT_DATA_LOAD');
export const AccountLogoutToLogin = createAction('ACCOUNT_LOGOUT_TO_LOGIN');

/**
 * Wipe all in-memory session state without running the logout sagas.
 *
 * `AccountLogout` / `AccountLogoutToLogin` also reset the store, but each is
 * watched by a saga that navigates the browser away (`getmrbl.ai` and
 * `/auth/login` respectively). Token-based sign-in needs the state reset
 * *without* the navigation, so it can immediately load a different account in
 * place — see `useTokenLogin`.
 */
export const SessionReset = createAction('SESSION_RESET');
